import React from 'react';
import styled, { css } from 'styled-components';
import { HuchaVentaValues } from '../../../../shared/models/hucha-values';
import { BonoCardBackground } from '../../../../shared/ui/bono-card-backgound';
import { HuchaCol, HuchaWrapper } from '../../../../shared/ui/layout-composition';
import { HuchaStandardCardC1 } from './hucha-standard-card-c1';
import { HuchaStandardCardC2 } from './hucha-standard-card-c2';
import { HuchaStandardCardC3 } from './hucha-standard-card-c3';

const HuchaStandardWrapper = styled(HuchaWrapper)`
	${HuchaCol} {
		max-width: 1000px;
	}
	& div[data-testid='card-c3-container'] {
		flex: 0 1 auto;
		width: 290px;
	}

	& .card-c1-logo-2l {
		display: none;
		min-width: 200px;
		max-width: 430px;
	}
	& .card-c1-logo-3l {
		min-width: 200px;
		max-width: 250px;
	}

	// Visibilidad de HuchaStandardButtons en C1 y C3 y Logo 2 o 3 líneas
	${({ $bonoPosventaExists }: { $bonoPosventaExists: boolean }) =>
		$bonoPosventaExists
			? css`
					div[data-testid='card-c1-buttons'] {
						display: none;
					}
					@media (min-width: 1260px) {
						div[data-testid='card-c1-buttons'] {
							display: block;
						}
						div[data-testid='card-c3-container'] {
							display: none;
						}
					}
				`
			: css`
					div[data-testid='card-c1-buttons'] {
						display: none;
					}
					div[data-testid='card-c3-container'] {
						display: block;
					}

					@media (min-width: 710px) and (max-width: 1044px) {
						div[data-testid='card-c1-buttons'] {
							display: block;
						}
						div[data-testid='card-c3-container'] {
							display: none;
						}
					}

					@media (min-width: 1045px) {
						& .card-c1-logo-2l {
							display: block;
						}
						& .card-c1-logo-3l {
							display: none;
						}
					}
				`}
`;

export const HuchaStandardCard = ({
	huchaValues,
	bonoPosventaExists,
}: {
	huchaValues: HuchaVentaValues;
	bonoPosventaExists: boolean;
}) => {
	return (
		<BonoCardBackground stretchContent data-testid="hucha-venta-card-container" wrap={'never'}>
			<HuchaStandardWrapper $bonoPosventaExists={bonoPosventaExists}>
				<HuchaCol $bonoPosventaExists={bonoPosventaExists}>
					<HuchaStandardCardC1 huchaValues={huchaValues} />
					<HuchaStandardCardC2 dineroHucha={huchaValues.dineroHucha} />
				</HuchaCol>

				<HuchaStandardCardC3 huchaValues={huchaValues} />
			</HuchaStandardWrapper>
		</BonoCardBackground>
	);
};
